<template>
  <div v-if="items.length" class="tender-note">
    <div v-for="(item, index) in items" :key="index" class="note-row">
      <span class="note-label">{{ item.label }}</span>
      <el-link v-if="item.url" :href="item.url" target="_blank" rel="noopener noreferrer" type="primary">查看原公告 <i class="el-icon-top-right" /></el-link>
      <span v-else class="note-value">{{ item.value }}</span>
    </div>
  </div>
  <div v-else class="plain-note">{{ remark || '—' }}</div>
</template>

<script>
import { parseTenderRemark } from '@/utils/tenderRemark'
export default {
  name: 'ClueRemark',
  props: { remark: String, source: String },
  computed: { items() { return parseTenderRemark(this.remark, this.source) } }
}
</script>

<style scoped>
.tender-note { padding: 16px 20px; background: #f8fafc; border-radius: 6px; }
.note-row { display: flex; align-items: baseline; gap: 18px; padding: 6px 0; line-height: 24px; }
.note-label { flex: 0 0 70px; color: #8590a2; font-size: 13px; }
.note-value { min-width: 0; color: #39475d; white-space: pre-wrap; overflow-wrap: anywhere; }
.note-row:first-child .note-value { font-weight: 600; color: #25334b; }
.plain-note { white-space: pre-wrap; overflow-wrap: anywhere; line-height: 26px; }
@media (max-width: 768px) { .tender-note { padding: 12px; } .note-row { gap: 10px; } }
</style>
